import React from 'react'

function FSW_program_details() {
  return (
    <div>
    {/* ------------------Mobile view----------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>The Full Stack Marvels</h1>
                    <p className='py-2'>Check out our Full Stack Web Development Course and go ahead in the tech industry. Get on board with this cutting-edge educational opportunity right away to launch a successful and exciting career!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Learn HTML, CSS, Bootstrap, SASS, JavaScript, DOM manipulation, jQuery, Node.js, SQL, React, WordPress, and Django as you embark on an extensive journey into Full Stack Web Development. This course covers the whole range, from basic concepts to sophisticated methods. Create dynamic web applications, become knowledgeable about server-side scripting, and obtain practical project experience. Develop your abilities and begin working as a skilled Full Stack Developer.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Full Stack Web Development</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* -------------------Desktop view--------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>The Full Stack Marvels</h1>
                    <p className='py-4'>Check out our Full Stack Web Development Course and go ahead in the tech industry. Get on board with this cutting-edge educational opportunity right away to launch a successful and exciting career!</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Learn HTML, CSS, Bootstrap, SASS, JavaScript, DOM manipulation, jQuery, Node.js, SQL, React, WordPress, and Django as you embark on an extensive journey into Full Stack Web Development. This course covers the whole range, from basic concepts to sophisticated methods. Create dynamic web applications, become knowledgeable about server-side scripting, and obtain practical project experience. Develop your abilities and begin working as a skilled Full Stack Developer.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Full Stack Web Development</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default FSW_program_details
